import AxiosConfig from '../../../config/AxiosConfig';

const useSystemSetup = () => {
  const systemSetup = async (update) => {
    try {
      const res = AxiosConfig.create('put', '/system/setup/')
        .call(update)
        .getResponseData();
      return res;
    } catch (err) {
      console.error('Failed to setup system:', err);
      throw new Error(`System setup failed: ${err.message}`);
    }
  };
  return { systemSetup };
};

export default useSystemSetup;
